module.exports = __webpack_public_path__ + "static/media/infoCuenta.f5aaf0af.svg";